import React from "react";

export default function Pagination({
  totalItems,
  pageSize,
  updatePage,
  currentPage,
  filters,
  updateFilters,
  featuredItems = 0
}) {
  const totalPages = Math.max(
    1,
    Math.ceil((totalItems - featuredItems) / pageSize)
  );
  return (
    <>
      {[...Array(totalPages)].map((e, i) => (
        <React.Fragment key={i}>
          {i + 1 > 1 && i + 2 === currentPage - 1 && (
            <a className="pagination-circle elipsis">...</a>
          )}
          <a
            onClick={() => updatePage("replace", { page: i + 1 }, filters, updateFilters)
            }
            className="pagination-circle"
            data-current-page={currentPage === i + 1}
            aria-current={currentPage === i + 1}
            data-first-last-page={i + 1 === 1 || i + 1 === totalPages}
            data-visible={
              i + 1 === currentPage - 1
              || i + 1 === currentPage
              || i + 1 === currentPage + 1
            }
            tabIndex={0}
          >
            {i + 1}
          </a>
          {i + 1 < totalPages && i === currentPage + 1 && (
            <a className="pagination-circle elipsis">...</a>
          )}
        </React.Fragment>
      ))}
    </>
  );
}
